import { useQuery } from "@tanstack/react-query";
import { usersApi } from "../api";

export const useGetUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => usersApi.getUsers(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetStakeholders = ({ params }: { params?: Record<string, any> }) => {
  return useQuery({
    queryKey: ["stakeholders" , params],
    queryFn: () => usersApi.getStakeholders({ params }),
    staleTime: 5 * 60 * 1000,
    enabled: !!params,
  });
};

export const useGetUser = (userId: number) => {
  return useQuery({
    queryKey: ["users", userId],
    queryFn: () => usersApi.getUser(userId),
    enabled: !!userId,
  });
};

